export default "__VITE_ASSET__vZsGNJlm__"